import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from "react";
import LucideProvider from "../LucideProvider";
import { SidebarProvider } from "../Sidebar";
import { ThemeProvider } from "../ThemeProvider";
import TooltipProvider from "../Tooltip/contexts";
import { jsx as _jsx } from "react/jsx-runtime";
function Provider(_ref) {
  var children = _ref.children,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? Object.freeze({}) : _ref$config;
  var disableProviders = config.disableProviders;
  var providerNameMap = {
    sidebar: SidebarProvider,
    tooltip: TooltipProvider,
    theme: ThemeProvider,
    lucide: LucideProvider
  };
  var childrenWithProviders = children;
  Object.entries(providerNameMap).forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      providerName = _ref3[0],
      SubProvider = _ref3[1];
    var isDisabled = disableProviders === null || disableProviders === void 0 ? void 0 : disableProviders[providerName];
    if (!isDisabled) {
      childrenWithProviders = /*#__PURE__*/_jsx(SubProvider, {
        config: config[providerName],
        children: childrenWithProviders
      });
    }
  });
  return childrenWithProviders;
}
Provider.displayName = "Provider";
export default Provider;